// add "flex-none" to children to make this component functional

import React, { useRef } from "react";
import { twMerge } from "tailwind-merge";

const HorizontalScroll = ({ children, className = "" }) => {
  // Reference to the scrollable container
  const scrollContainerRef = useRef(null);

  // Function to handle mouse drag to scroll
  const handleMouseDown = (event) => {
    const scrollContainer = scrollContainerRef.current;
    scrollContainer.style.cursor = "grabbing"; // Change the cursor to grabbing
    scrollContainer.dataset.isDown = true;
    scrollContainer.dataset.startX = event.pageX - scrollContainer.offsetLeft;
    scrollContainer.dataset.scrollLeft = scrollContainer.scrollLeft;
  };

  const handleMouseLeaveOrUp = () => {
    const scrollContainer = scrollContainerRef.current;
    scrollContainer.style.cursor = "grab"; // Change the cursor back to grab
    scrollContainer.dataset.isDown = false;
  };

  const handleMouseMove = (event) => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer.dataset.isDown === "true") {
      const x = event.pageX - scrollContainer.offsetLeft;
      const walk = (x - scrollContainer.dataset.startX) * 2; // Multiply for faster scrolling
      scrollContainer.scrollLeft = scrollContainer.dataset.scrollLeft - walk;
    }
  };

  return (
    <div
      ref={scrollContainerRef}
      className={twMerge(
        " flex overflow-x-auto gap-x-0 px-8 py-4 cursor-grab no-scrollbar ",
        className
      )}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeaveOrUp}
      onMouseUp={handleMouseLeaveOrUp}
      onMouseMove={handleMouseMove}
    >
      {children}
    </div>
  );
};

export default HorizontalScroll;
